export default "__VITE_ASSET__CwIApIwQ__"